import React, { useEffect } from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';
import useHover from '../../../../../../hooks/useHover';
import { getImgixUrl } from '../../../../../../utils/helper';

const Wrapper = styled.button`
  margin-right: 0;
  margin-bottom: 0;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  position: relative;

  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.35' : '1')};

  &:hover {
    outline: none;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({ disabled }) =>
      disabled
        ? `linear-gradient(to top left,
             rgba(0,0,0,0) 0%,
             rgba(0,0,0,0) calc(50% - 0.8px),
             rgba(0,0,0,1) 50%,
             rgba(0,0,0,0) calc(50% + 0.8px),
             rgba(0,0,0,0) 100%)`
        : 'transparent'};
  }

  .fabric-image-container {
    border-radius: 0;
    border: ${({ theme, selected, isHovered }) =>
      theme.old ? (
        selected
        ? '3px solid #2A5CAF'
        : isHovered
        ? '3px solid #6a99cc'
        : '3px solid white'
      ) : (
        selected
        ? `3px solid ${theme.colors.french}`
        : isHovered
        ? '3px solid #6a99cc'
        : '3px solid white'
      )};

    .fabric-image {
      border-radius: 0;

      width: 100%;
      height: 100%;

      border: 3px solid white;
    }
  }
`;

const initialState = {
  name: '',
  collaborator: '',
  image: '',
  description: ''
};

function FabricItem({
  image,
  name,
  collaborator,
  setHoveredFabric,
  onClick,
  selected,
  fabric
}) {
  const [hoverRef, isHovered] = useHover();

  useEffect(() => {
    if (isHovered && fabric.treatment?.id != 2 && fabric.is_available_on_pdp) {
      setHoveredFabric(fabric);
    } else {
      setHoveredFabric(initialState);
    }
  }, [isHovered]);

  return (
    <Wrapper
      ref={hoverRef}
      onClick={onClick}
      selected={selected}
      isHovered={!fabric.is_available_on_pdp ? false : isHovered}
      disabled={!fabric.is_available_on_pdp}
    >
      <div className="border-container">
        <div className="fabric-image-container">
          {/* fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1.2&fp-debug=false */}
          <Imgix
            imgixParams={{ auto: 'compress,format' }}
            className="fabric-image"
            sizes="(min-width: 993px) 90px,
            (min-width: 601px) 16vw,
            (min-width: 361px) 22vw,
            25vw"
            src={getImgixUrl(image)}
            htmlAttributes={{
              alt: name,
              loading: 'lazy'
            }}
          />
        </div>
      </div>
    </Wrapper>
  );
}

export default FabricItem;
